<script setup>
import { useI18n } from 'vue-i18n';
import LaisDrawer from 'dashboard/components-next/LaisDrawer.vue';

defineProps({
  show: { type: Boolean, default: false },
});

const emit = defineEmits(['close', 'apply', 'clear']);
const { t } = useI18n();
</script>

<template>
  <LaisDrawer
    :show="show"
    side="right"
    size="sm"
    :title="t('LEADS.FILTER_DRAWER.TITLE')"
    @close="emit('close')"
  >
    <template #body>
      <div class="grid gap-4">
        <slot />
      </div>
    </template>
    <template #footer>
      <div class="grid gap-2 sm:grid-cols-[auto_1fr]">
        <button
          type="button"
          class="rounded-lais border border-lais-border-soft bg-lais-bg-card px-4 py-2.5 text-lais-label-sm font-semibold text-lais-text transition hover:border-lais-primary hover:text-lais-primary"
          @click="emit('clear')"
        >
          {{ t('LEADS.FILTER_DRAWER.CLEAR') }}
        </button>
        <button
          type="button"
          class="rounded-lais bg-lais-primary px-4 py-2.5 text-lais-label-sm font-semibold text-white"
          @click="emit('apply')"
        >
          {{ t('LEADS.FILTER_DRAWER.APPLY') }}
        </button>
      </div>
    </template>
  </LaisDrawer>
</template>
